export class ChatSession {
    chatID: string;
    userParticipantID: string;
    repParticipantID: string;
    repWelcomeMessage: string;
    repDisplayName: string;
    repParticipantName: string;
    userDisplayName: string;
    repImageURL: string;
    repImage: string;
    isRepInitChat: boolean;
    isChatInitiated: boolean;
    isRepInitChatInitiated: boolean;
    typingIndicator: string;
    isDisconnectEventReceived: boolean;
    isTransferEventReceived: boolean;
    chatContent: string;
    lastRepChatMessage: string;
    showRepInitAlert: boolean;
}
